'use client';

import { cn } from '@/lib/ui/cn';
import { PropsWithClassName } from '@/types/shared';

type Props = PropsWithClassName;

export const BackToTop: React.FC<Props> = ({ className }) => (
  <button
    className={cn(
      'BackToTop',
      'flex w-full cursor-pointer items-center justify-center self-stretch py-4 text-[21px] leading-[130%] text-black underline',
      className
    )}
    type='button'
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
  >
    Back to top
  </button>
);
